import { Outlet } from "react-router-dom";
import { Header } from "../components/Header.js";
import { Footer } from "../components/Footer.js";
import styles from "./Layout.module.css";

export function Layout() {
  return (
    <div className={styles.page}>
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
}
